'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.submitFormHandler = submitFormHandler;

var _effects = require('redux-saga/effects');

var _reduxSaga = require('redux-saga');

var _sagaUtils = require('@wh/saga-utils');

var _constants = require('./../constants');

var _actions = require('./actions');

var _actions2 = require('../login-component/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(submitFormHandler),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(watchLoginFormSubmit);

/**
 * Process submit form
 * @param {Object} action Action of type LOGIN_BUTTON_CLICKED
 * @returns {Iterator} Iterator
 */
function submitFormHandler(action) {
    var formData, username, password, keepMeLoggedIn, rememberUsername, casData;
    return _regenerator2.default.wrap(function submitFormHandler$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    formData = action.formData;
                    username = formData.getIn(['username']);
                    password = formData.getIn(['password']);
                    keepMeLoggedIn = !!formData.getIn(['keepMeLoggedIn']);
                    rememberUsername = !!formData.getIn(['rememberUsername']);
                    _context.prev = 5;
                    _context.next = 8;
                    return action.casClient.login(username, password, keepMeLoggedIn, rememberUsername);

                case 8:
                    casData = _context.sent;
                    _context.next = 11;
                    return (0, _effects.put)((0, _actions.userLoggedIn)(casData));

                case 11:
                    _context.next = 13;
                    return (0, _effects.put)((0, _actions2.trackingEvent)(_constants.TRACKING_EVENT_NAME_LOGGED_IN));

                case 13:
                    _context.next = 21;
                    break;

                case 15:
                    _context.prev = 15;
                    _context.t0 = _context['catch'](5);
                    _context.next = 19;
                    return (0, _effects.put)((0, _actions.userLoginFailed)(_context.t0));

                case 19:
                    _context.next = 21;
                    return (0, _effects.put)((0, _actions2.trackingEvent)(_constants.TRACKING_EVENT_NAME_FORM_ERROR, {
                        errorMessageName: _context.t0 && _context.t0.failure ? _context.t0.failure : 'other'
                    }));

                case 21:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[5, 15]]);
}

/**
 * Submit login form generator function
 * @returns {void}
 */
function watchLoginFormSubmit() {
    return _regenerator2.default.wrap(function watchLoginFormSubmit$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.call)(_reduxSaga.takeLatest, _constants.LOGIN_BUTTON_CLICKED, submitFormHandler);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

exports.default = (0, _sagaUtils.setupSagaTarget)(watchLoginFormSubmit, true, true);
//# sourceMappingURL=sagas.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/login-form/sagas.js
// module id = 492
// module chunks = 0